import { UploadOutlined } from '@ant-design/icons';
import { default as Space } from 'antd/es/space';
import { useState } from 'react';

import { useGetDisbursementPaymentInstruments } from 'api';
import { Restricted } from 'containers/Restricted';

import { useOrganisationId } from 'hooks/context';
import { useGoogleAnalyticsDispatcher } from 'hooks/useGoogleAnalyticsDispatcher';

import { PrimaryButton } from '@atoms/buttons/PrimaryButton';
import { SecondaryButton } from '@atoms/buttons/SecondaryButton';
import { DocumentCopy } from '@atoms/Icon/DocumentCopy';

import { CreateBatchTemplateDialog } from './CreateBatchTemplateDialog';
import { UploadBatchDialog } from './UploadBatchDialog/UploadBatchDialog';

import type { RefetchBatchesType } from '.';

export const BatchesActionButtons = ({
  refetchBatches
}: {
  refetchBatches: RefetchBatchesType;
}) => {
  const [createBatchOpen, setCreateBatchOpen] = useState(false);
  const [uploadBatchOpen, setUploadBatchOpen] = useState(false);

  const organisationId = useOrganisationId<number>();
  const { data: { data: paymentInstruments } = {} } =
    useGetDisbursementPaymentInstruments(organisationId);

  const dispatchGAEvent = useGoogleAnalyticsDispatcher();

  return (
    <Space>
      <Restricted requiredPermission="payout_batches:manage">
        <SecondaryButton
          icon={<DocumentCopy />}
          onClick={() => setCreateBatchOpen(true)}
          className="h-9"
        >
          Create Batch template
        </SecondaryButton>
      </Restricted>
      {createBatchOpen && paymentInstruments ? (
        <CreateBatchTemplateDialog
          open={createBatchOpen}
          setOpen={setCreateBatchOpen}
          paymentInstrumentsData={paymentInstruments}
        />
      ) : null}

      <Restricted requiredPermission="payout_batches:manage">
        <PrimaryButton
          icon={<UploadOutlined />}
          onClick={() => {
            dispatchGAEvent('create_batch_intent');
            setUploadBatchOpen(true);
          }}
          className="h-9"
        >
          Upload batch file
        </PrimaryButton>
      </Restricted>
      {uploadBatchOpen ? (
        <UploadBatchDialog
          open={uploadBatchOpen}
          onClose={() => setUploadBatchOpen(false)}
          setIsCreateBatchDialogVisible={setCreateBatchOpen}
          refetchBatches={refetchBatches}
        />
      ) : null}
    </Space>
  );
};
